import { ComponentClass } from 'react';
export { ComponentClass };
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TimePaneEventDetails", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const EventDetails = createLazyComponent(lazyModule, m => m.TimePanelEventDetails);
